var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFillBookmarked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1998 22.3504L11.9998 17.8504L4.7998 22.3504V2.55039C4.7998 2.3117 4.89463 2.08278 5.06341 1.91399C5.23219 1.74521 5.46111 1.65039 5.6998 1.65039H18.2998C18.5385 1.65039 18.7674 1.74521 18.9362 1.91399C19.105 2.08278 19.1998 2.3117 19.1998 2.55039V22.3504Z",
    fill: "#0066CC",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFillBookmarked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fillBookmarked.449cdde8023930d991f268bbd0f53e47.svg";